import { formatNumber } from 'core/service/lib/number-format'

const dashedOutOrWithPrecision = (value, precision, isRound = true) =>
  value === 0 ? '-' : formatNumber(value, precision, isRound)

export const PolicyValueRowMRTA = ({ yearEndPolicy, basicSumAssured, riderSumAssured, surrenderCash }) => {
  return (
    <tr id={`policy-value-row-${yearEndPolicy}`}>
      <td className="policy-value-year-end-policy">{yearEndPolicy}</td>
      <td className="policy-value-basic-sum-assured">{dashedOutOrWithPrecision(basicSumAssured, 0)}</td>
      <td className="policy-value-rider-sum-assured">{dashedOutOrWithPrecision(riderSumAssured, 0)}</td>
      <td className="policy-value-surrender-cash">{dashedOutOrWithPrecision(surrenderCash, 0)}</td>
    </tr>
  )
}
export const PolicyValueRowGLTSP = ({ yearEndPolicy, basicSumAssured, surrenderCash }) => {
  return (
    <tr id={`policy-value-row-${yearEndPolicy}`}>
      <td className="policy-value-year-end-policy">{yearEndPolicy}</td>
      <td className="policy-value-basic-sum-assured">{dashedOutOrWithPrecision(basicSumAssured, 0)}</td>
      <td className="policy-value-surrender-cash">{dashedOutOrWithPrecision(surrenderCash, 0)}</td>
    </tr>
  )
}
